import affiliate_styles from '@/styles/affiliate.module.scss';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AffiliatorSignup: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === '/affiliators/signup') return;
    setTimeout(() => {
      document.documentElement.scrollIntoView({
        block: 'end',
      });
    }, 100);
  }, [pathname]);

  return (
    <div className='container mt-4'>
      <h1 className={affiliate_styles.signup_title}>
        GirlsFundingアフィリエイトパートナー
      </h1>
      <p>
        GirlsFundingアフィリエイトパートナーは「GirlsFunding
        」が提供するインフルエンサー向けのアフィリエイトプログラムです。
        <br />
        ※GirlsFundingアフィリエイトパートナーになるにはGirlsFunding株式会社のライセンスが必要です。
      </p>

      <h2 className={affiliate_styles.signup_title}>仕組みについて</h2>
      <p>
        ＳＮＳ・ＷＥＢ・直接の招待などで「GirlsFunding」の宣伝をして頂き登録人数に応じて成果報酬をお支払いします。
        <br />
        ※広告素材は資格取得後GirlsFunding株式会社が提供します。
      </p>
      <h2 className={affiliate_styles.signup_title}>報酬について</h2>
      <table className='table table-bordered'>
        <tr>
          <th>無料会員（両性）</th>
          <td>1会員 10円(税込)</td>
        </tr>
        <tr>
          <th>有料会員（男性）</th>
          <td>1会員 5,000円(税込)</td>
        </tr>
        <tr>
          <th>有料会員（女性）</th>
          <td>1会員 2,500円(税込)</td>
        </tr>
      </table>

      <h2 className={affiliate_styles.signup_title}>支払いについて</h2>
      <p>
        ※月末締め翌々月末日ごろのお支払いです。
        <br />
        ※お支払い条件は報酬合計額10,000円以上からです。
        <br />
        ※振り込み手数料はGirlsFundingアフィリエイトパートナー様の負担です。
      </p>

      <h2 className={affiliate_styles.signup_title}>
        アフィリエイトパートナー申し込み
      </h2>
      {children}
    </div>
  );
};

export default AffiliatorSignup;
